import type { ICategory } from "~/typings/categories";
import type { IGoodCategoryResponse, IPromoCategoryResponse } from "~/typings/api/categories";

export const PROMO_ROOT_KEY: ICategory["key"] = "p0000";
export const GOODS_ROOT_KEY: ICategory["key"] = "g0000";

export const PROMO_IGNORE_IDS: IPromoCategoryResponse["id"][] = ["2"];
export const GOODS_IGNORE_IDS: IGoodCategoryResponse["id"][] = [1];
